import generalUpload from "../_section/upload.class";

export class userBerCertificateUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: []
}

export class adminBerCertificateUpload extends userBerCertificateUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.expiryDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate().add(1, 'year'),
            })
        }
    }


}
